/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AccountInfo } from '@azure/msal-common';
import * as auth from '../auth';
import { ErrorService } from '../services/error.service';
import { GeneralService } from '../services/general.service';
import { AdvancedSearchFilter, Asset, AssetNormalized, Channel, Indication, IndicationNormalized, ListItem, ReferenceData } from '../services/models';
import { ReferenceDataService } from '../services/reference-data.service';
import { SearchService } from '../services/search.service';
import { filter, map } from 'rxjs/operators';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgbDropdown, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { EventBrokerService } from '../services/event-broker.service';
import { environment } from 'src/environments/environment';
import { SideBarService } from '../services/side-bar.service';
import { AnalyticsService } from '../services/analytics.service';
import { BrandTrackerService } from '../brand-tracker/brand-tracker.service';
import { brandTrackerData } from 'src/app/services/models';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @ViewChild(NgSelectComponent) public channelSelect: NgSelectComponent;
  @ViewChild(NgSelectComponent) public taSelect: NgSelectComponent;
  @ViewChild(NgSelectComponent) public assetSelect: NgSelectComponent;
  @ViewChild(NgSelectComponent) public indicationSelect: NgSelectComponent;
  @ViewChild(NgbDropdown) public channelNavigator: NgbDropdown;

  referenceData: ReferenceData;
  pageTitle = '';
  queryText = '';

  srcTAs: ListItem[] = [];
  srcAssets: AssetNormalized[] = [];
  srcIndications: IndicationNormalized[] = [];

  brandName:string="";
  imageSrc:string="assets/img/accesshublogo.png";
  baseUrl:string="./"

  urlPath:string = "";

  selectAnOption = {
    Title: 'Select an option'
  } as ListItem;

  get emptyAdvancedSearchFilter(): AdvancedSearchFilter {
    return {
      Asset: this.selectAnOption.Title,
      ChannelTitle: this.selectAnOption.Title,
      Indication: this.selectAnOption.Title,
      TA: this.selectAnOption.Title
    };
  }

  get isSignoutVisible(): boolean {
    return environment.environment === 'Development';
  }
  advancedSearchFilter: AdvancedSearchFilter = this.emptyAdvancedSearchFilter;
  appliedAdvancedSearchFilter: AdvancedSearchFilter;


  constructor(public router: Router,
    private activatedRoute: ActivatedRoute,
    private referenceDataService: ReferenceDataService,
    public generalService: GeneralService,
    public searchService: SearchService,
    private errorService: ErrorService,
    private eventBroker: EventBrokerService,
    private sidebarService: SideBarService,
    private analyticsService: AnalyticsService,
    private brandTrackerService:BrandTrackerService) {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        this.sidebarService.hide();

        if (this.channelNavigator !== undefined) {
          this.channelNavigator.close();
        }
        const child = this.activatedRoute.firstChild;
        this.urlPath = child.snapshot.routeConfig.path;
        if (child.snapshot.data['title']) {          
          return child.snapshot.data['title'];          
        }       
        return '';
      })
    ).subscribe((title: string) => {  
      this.pageTitle = title;
      if (title) {
        if(title.toLowerCase() != "search")
        this.analyticsService.trackChannelsAnalyticsInfo(title);
      }
      this.updateBannerTheme();
    });
    console.log(this.router.url);
    
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryText = params.query || '';
    }); 

  }
  
  get isAuthenticated(): boolean {
    return auth.isAuthenticated;
  }

  get activeAccount(): AccountInfo {
    return auth.msalInstance.getActiveAccount();
  }

  allChannelOptions: Channel[] = [];
  channelOptions: Channel[] = [this.selectAnOption];


  allTaOptions: ListItem[] = [];
  taOptions = [this.selectAnOption];

  allAssetOptions: Asset[] = [];
  assetOptions: Asset[] = [this.selectAnOption];

  allIndicationOptions: Indication[] = [];
  indicationOptions: Indication[] = [this.selectAnOption];

  requestsList: brandTrackerData[] = []; 
  brandList=[];

  async ngOnInit(): Promise<void> {
    try {
      this.referenceData = await this.referenceDataService.get();
      this.allChannelOptions = this.referenceData.Channels.sort((x, y) => x.sortOrder !== y.sortOrder ? x.sortOrder - y.sortOrder : (x.Title > y.Title ? 1 : -1));
      this.channelOptions = [this.selectAnOption, ...this.allChannelOptions];
      this.allTaOptions = this.referenceData.TAs.sort((x, y) => x.Title > y.Title ? 1 : -1);
      this.taOptions = [this.selectAnOption, ...this.allTaOptions];
      this.allAssetOptions = this.referenceData.Assets.sort((x, y) => x.Title > y.Title ? 1 : -1);
      this.assetOptions = [this.selectAnOption, ...this.allAssetOptions];
      this.allIndicationOptions = this.referenceData.Indications.sort((x, y) => x.Title > y.Title ? 1 : -1);
      this.indicationOptions = [this.selectAnOption, ...this.allIndicationOptions];
      this.buildDataFilters();
    }
    catch (error) {
      this.errorService.show('Failed to get reference data', error);
    }
    
    this.brandName="";
    console.log(this.urlPath);
    // if(this.urlPath=='atlas-search'){
    //   this.advancedSearchFilter.ChannelTitle = 'access atlas';
    // }
    await this.loadAllRequests();  
  }
  async loadAllRequests(): Promise<void> {     
    const brandListPromise = this.brandTrackerService.getAllBrandNames();
    try {
      this.requestsList = await brandListPromise;    
      this.brandList = [...this.requestsList];          
    }
    catch (error) {
      this.errorService.show('Failed to get AEM Summaries', error);
    }     
    this.updateBannerTheme(); 
  }
  taChanged(selectedTa: ListItem) {
    if (selectedTa && selectedTa.Id) {
      this.assetOptions = [this.selectAnOption, ...this.allAssetOptions.filter(x => x.TAId === selectedTa.Id)];
      this.indicationOptions = [this.selectAnOption, ...this.allIndicationOptions.filter(x => x.TAId === selectedTa.Id)];

      if (this.advancedSearchFilter.Asset) {
        if (!this.assetOptions.some(x => x.Title === this.advancedSearchFilter.Asset)) {
          this.advancedSearchFilter.Asset = this.selectAnOption.Title;
        }
      }

      if (this.advancedSearchFilter.Indication) {
        if (!this.indicationOptions.some(x => x.Title === this.advancedSearchFilter.Indication)) {
          this.advancedSearchFilter.Indication = this.selectAnOption.Title;
        }
      }
    }
    else {
      this.assetOptions = [this.selectAnOption, ...this.allAssetOptions];
      this.indicationOptions = [this.selectAnOption, ...this.allIndicationOptions];
    }
  }

  buildDataFilters(): void {
    this.srcTAs = this.referenceData.TAs;

    this.srcAssets = [];
    this.referenceData.Assets.forEach(asset => {
      const normIdx = this.srcAssets.findIndex(x => x.Title === asset.Title);

      if (normIdx < 0) {
        this.srcAssets.push({ Title: asset.Title, Items: [asset] });
      } else {
        const normAsset = this.srcAssets[normIdx];

        if (normAsset.Items.findIndex(y => y.Id == asset.Id) === -1) {
          normAsset.Items.push(asset);
        }
      }
    });

    this.srcIndications = [];
    this.referenceData.Indications.forEach(indication => {
      const normIdx = this.srcIndications.findIndex(x => x.Title === indication.Title);

      if (normIdx < 0) {
        this.srcIndications.push({ Title: indication.Title, Items: [indication] });
      } else {
        const normIndication = this.srcIndications[normIdx];

        if (normIndication.Items.findIndex(y => y.Id == indication.Id) === -1) {
          normIndication.Items.push(indication);
        }
      }
    });
  }

  isHomeComponent(): boolean {   
    if (window.location.pathname == '/'){
     if(this.brandName!=""){
        this.brandName="";
        this.updateBannerTheme();
     };    
      return true;
    }else {
      return false;
    }
  }

  searchKeyPress(e: KeyboardEvent, searchPopOver: NgbPopover) {
    if (e.code === 'Enter') {
      searchPopOver.close();
      this.goToSearch();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  goToSearch(popover?: any): void {
    popover?.close();
    this.applyAdvancedSearchFilter(popover);
    this.analyticsService.trackSearchAnalyticsInfo(this.queryText);
    const queryString = `?query=${encodeURIComponent(this.queryText)}`;
    console.log(this.advancedSearchFilter.ChannelTitle);
    let url="";
    // if(this.advancedSearchFilter.ChannelTitle.toLowerCase()=='access atlas'){
    //   url = `/atlas-search${queryString}`;
    // }else{
      url = `/search${queryString}`;
   // }
    
    let shouldNavigate = true;

    if (location.pathname === '/search' && location.search === queryString) {
      this.eventBroker.publish('AdvancedSearchFilterRequested', this.appliedAdvancedSearchFilter);
      shouldNavigate = false;
    }
    else if (this.appliedAdvancedSearchFilter) {
      localStorage.setItem('AdvancedSearchFilter', JSON.stringify(this.appliedAdvancedSearchFilter));
    }

    if (!this.appliedAdvancedSearchFilter) {
      localStorage.removeItem('AdvancedSearchFilter');
    }

    if (shouldNavigate) {
      if (location.pathname === '/search') this.router.navigateByUrl(url);
      else window.open(url);
    }
    this.advancedSearchFilter = this.emptyAdvancedSearchFilter;
    this.appliedAdvancedSearchFilter = undefined;
  }

  async signOut(): Promise<void> {
    if (await auth.signOut()) {
      this.router.navigateByUrl('/account/signed-out');
    }
  }

  get tasFilterCountResume(): number { return this.generalService.appliedTAIds.length - 1; }

  get tasFilterText(): string {
    const filter = this.referenceData.TAs.filter(x => this.generalService.appliedTAIds.includes(x.Id));
    return filter.length > 0 ? filter[0].Title : '';
  }

  get assetsFilterCountResume(): number { return this.generalService.appliedAssetIds.length - 1; }

  get assetsFilterText(): string {
    const filter = this.srcAssets.filter(x => this.generalService.appliedAssetIds.some(y => y.Title === x.Title))
    return filter.length > 0 ? filter[0].Title : '';
  }

  get indicationsFilterCountResume(): number { return this.generalService.appliedIndicationIds.length - 1; }

  get indicationsFilterText(): string {
    const filter = this.srcIndications.filter(x => this.generalService.appliedIndicationIds.some(y => y.Title === x.Title));
    return filter.length > 0 ? filter[0].Title : '';
  }

  applyAdvancedSearchFilter(popOver?: NgbPopover) {
    const f = this.advancedSearchFilter;
    const noOption = this.selectAnOption.Title;
    if (f.Asset && f.Asset !== noOption || f.ChannelTitle && f.ChannelTitle !== noOption ||
      f.Indication && f.Indication !== noOption || f.TA && f.TA !== noOption) {
      const af = this.appliedAdvancedSearchFilter = {} as AdvancedSearchFilter;
      af.Asset = f.Asset === noOption ? undefined : f.Asset;
      af.ChannelTitle = f.ChannelTitle === noOption ? undefined : f.ChannelTitle;
      af.Indication = f.Indication === noOption ? undefined : f.Indication;
      af.TA = f.TA === noOption ? undefined : f.TA;
    }
    else {
      this.appliedAdvancedSearchFilter = undefined;
    }
    popOver?.close();
  }

  resetAdvancedSearchFilter() {
    this.advancedSearchFilter = this.emptyAdvancedSearchFilter;
    this.applyAdvancedSearchFilter();
    this.assetOptions = [this.selectAnOption, ...this.allAssetOptions];
    this.indicationOptions = [this.selectAnOption, ...this.allIndicationOptions];
  }
  navigateToTaxonomy() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/glossary`])
    );
      window.open(url, '_blank');
  }

  async updateBannerTheme() {
    let bList=this.brandList[0]?this.brandList[0]:""; 
    this.brandName=bList?(bList.Title ? bList.Title.toLowerCase():""):"";
    if(this.pageTitle.toLowerCase()=='brand tracker'){
      this.imageSrc = bList?(bList.BrandLogoUrl?bList.BrandLogoUrl:""):""; 
      document.getElementsByClassName('guide-info-container')[0].classList.add('brand-tracker');
    }else{
      this.imageSrc = "assets/img/accesshublogo.png"; 
      document.getElementsByClassName('guide-info-container')[0].classList.remove('brand-tracker');   
    }
    
    if(this.pageTitle.toLowerCase()=='contract rights'){
       this.pageTitle = 'ContractRight';
    }
    
    let selectedChannel = this.allChannelOptions.filter(e => e.Title== this.pageTitle);
  }

  navigateToMainPage(){    
    if(this.brandName=="botox"){
      this.router.navigate(['/brand-tracker/'+this.brandTrackerService.brandName]);
    }else{
      this.router.navigate(['./']);
    }
     
  }
}
